// home — am. Part of the am i18n bundle; merged by ./index.js

export default {
  mpTopDashboard: 'ዳሽቦርድ',
  mpTopRegister: 'ተመዝገብ',
  mpSearchCategory: 'ምድብ',
  mpSearchAllCategories: 'ሁሉም ምድቦች',
  mpSearchLocation: 'አካባቢ',
  mpSearchAllCities: 'ሁሉም ከተሞች',
  mpSearchKeyword: 'ምን እየፈለግን ነው?',
  mpSearchBtn: 'ፈልግ',
  mpTapToRead: 'ለማንበብ ንካ ▼',
  mpProducts: 'ምርቶች',
};
